export default __webpack_public_path__ + "static/media/coaching_icon.75a32170.webp";